import { render, staticRenderFns } from "./ProjectStockStatusDialog.vue?vue&type=template&id=e261827e&"
import script from "./ProjectStockStatusDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectStockStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports